export default "__VITE_ASSET__B1kR3dWk__"